import { render, staticRenderFns } from "./BryntumResourceCombo.vue?vue&type=template&id=db88b860"
import script from "./BryntumResourceCombo.vue?vue&type=script&lang=js"
export * from "./BryntumResourceCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports